export const SWITCH_SITE_STATUS_ERROR__NOT_FOUND = 'NOT_FOUND';
export const SWITCH_SITE_STATUS_ERROR__SITE_STATUS_WRONG = 'SITE_STATUS_WRONG';

export const DELETE_SITE_ERROR__NOT_FOUND = 'NOT_FOUND';
export const DELETE_SITE_ERROR__SITE_STATUS_WRONG = 'SITE_STATUS_WRONG';

export const LOAD_SITE_ERROR__NOT_FOUND = 'NOT_FOUND';
